import { render, staticRenderFns } from "./IconYpoWhite.vue?vue&type=template&id=19f48ae5&"
import script from "./IconYpoWhite.vue?vue&type=script&lang=js&"
export * from "./IconYpoWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports